<script lang="ts" setup>
import type {Button} from "~/types/button";
import {NuxtLinkLocale, SvgoRightArrow, NuxtLink} from "#components";
import type {Component} from "vue";
import {isLinkTypeExternal, isLinkTypeAnchor} from "#magnolia-layer/types/api";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import {withoutLeadingSlash} from "ufo";

if (import.meta.client) {
  gsap.registerPlugin(ScrollToPlugin);
}
interface Props {
  button?: Button;
  icon?: Component | null;
}

const props = withDefaults(defineProps<Props>(), {
  icon: SvgoRightArrow,
  button: {
    type: "default",
  },
});

const resolvedLink = computed(() => {
  if (!props.button) return;
  const link = resolveLink(props.button);

  // TODO: Because JcrReferenceResolver doesn't resolve current page we need to do this, maybe we should look into
  //  fixing the reference resolver instead of doing this
  if (isAnchor.value) {
    link.link = withoutLeadingSlash(link.link);
  }

  return link;
});

const isExternal = computed(() => {
  return isLinkTypeExternal(props.button.link);
});

const isAnchor = computed(() => {
  return isLinkTypeAnchor(props.button.link);
});

// TODO: Because JcrReferenceResolver doesn't resolve current page we need to do this, maybe we should look into
//  fixing the reference resolver instead of doing this
function customClick(e: Event) {
  if(isAnchor) {
    e.preventDefault();

    if (!resolvedLink.value) return;
    smoothScroll(e, resolvedLink.value?.link);
  }
}

function smoothScroll(event: Event, link: string) {
  if (!link.startsWith('#')) return;

  event.preventDefault();
  const el: HTMLElement | null = document.querySelector(link);

  if(!el) return;

  const logoItems = document.getElementsByClassName("logo");
  if (!logoItems) return;
  const logo = logoItems.item(0);
  if (!logo) return;
  const logoHeight = logo.clientHeight;

  const y = el.offsetTop - logoHeight * 2;

  gsap.to(window, {
    duration: 1,
    scrollTo: {y: y, autoKill: false },
    ease: "power1.inOut",
    onComplete: () => history.replaceState(null, '', link)
  });

}
</script>

<template>
  <component
      :is="isExternal || isAnchor ? NuxtLink : NuxtLinkLocale"
      :href="resolvedLink?.link ?? '#'"
      :target="resolvedLink?.target"
      :class="'trimm-button ' + `trimm-button--${button.type}`"
      @click="customClick"
  >
    <span v-if="button.label" :class="{'pr-4': icon !== null}">
      {{ button.label }}
    </span>
    <component v-if="icon !== null" :is="icon" />
  </component>
</template>

<style lang="scss" scoped></style>
